import logo from "../assets/img/logo.png";
import logoWhite from "../assets/img/logo-white.png";

export default function Logo() {
  return (
    <div className="w-full max-w-md pt-5 mx-auto sm:py-10">
      <img src={logo} alt="Logo" className="block dark:hidden" />
      <img src={logoWhite} alt="Logo" className="hidden dark:block" />
    </div>
  );
}
